import BaseModel from '../core/BaseModel'
export default class ServicePackProduct extends BaseModel {
    constructor() {
        super({
                name: "service_pack_product",
                tableName: 'core_service_pack_product',
                display_key: 'name'
            },
            {
                id: {
                    name: 'id',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                obj_product: {
                    refs: 'service_pack_id obj_product { id model_code name } obj_service_pack { id code name description }',
                    display: false
                },

            },)
    }

}